// eslint-disable-next-line import/no-named-default
import { default as styled } from 'styled-components'
import { Form } from 'semantic-ui-react'
import { Components, Theme } from '@kyndio/kynd-shared-components'

const SubmitContainer = styled.div`
min-height: 2.3em;
overflow: visible;
`
const SubmitButton = styled(Components.RegularButton)`
float: right !important;
`

const ModalButtonsContainer = styled.div`
  width: 90%;
  margin-top: 1em;
  display: flex;
  justify-content: space-between;
`
const StyledForm = styled(Components.StyledForm)`
  justify-content: inherit;
  height: 100vh;

  & > .fields-section{
      overflow-y: hidden;
      height: 100%;
      max-width:100%;
  }
  
  & > .submit-section-balancer,
  & > .submit-section {
      min-height: 5.71em;
  }
  
  & > .submit-section-balancer {
      display: flex;
      align-items: flex-end;
  }

`
const EmailsContainer = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
`

const EmailContainer = styled.span`
  margin-left: 0.35em;
`

const InviteMessage = styled(Components.InviteMessage)`
  font-size: 1.14rem;
  margin-bottom: 0.6em;
`
const BackLink = styled.a`
  cursor: pointer;
  color: ${Theme.colors.kynd.coral};
  padding-left: 8em;
  
  &:hover {
    color: ${Theme.colors.kynd.coral};
  }
`

const ModalContent = styled.div`
  white-space: pre-wrap;
`

const EmailInput = styled(Form.Field)`
  & > div {
    display: inline-block;

    & input {
      text-align: right !important;
    }
`

const FieldWrapper = styled(Components.FieldWrapper)`
  margin-bottom: 0.4em;
`

const Wrapper = styled.div`
  margin-bottom: 1.4em !important;

  & > label {
    font-weight: 700;
    margin-right: 0.85714286em;
  }
`

export {
  SubmitContainer,
  SubmitButton,
  ModalButtonsContainer,
  StyledForm,
  EmailsContainer,
  EmailContainer,
  InviteMessage,
  BackLink,
  ModalContent,
  EmailInput,
  FieldWrapper,
  Wrapper
}
